export default "__VITE_ASSET__CkdG04Xx__"